import { getCategoriesWithFamilies } from "../main";
import { getUpcomingEvents } from "../events";

export const checkForReload = () => async (dispatch) => {
  await dispatch(getCategoriesWithFamilies());
  await dispatch(getUpcomingEvents({pageNumber: 1}));
};
